const DEFAULT_VALUES = {
  interestRate: 20,
  tenure: 50,
  compType: "Monthly",
};

export const STATIC_SCHEMES = [
  { schemeType: "Daily/Pigmy Savings", defaults: DEFAULT_VALUES },
  { schemeType: "Gold Savings", defaults: DEFAULT_VALUES },
  { schemeType: "Goal Savings", defaults: DEFAULT_VALUES },
];

export const normalize = (str) => (str || "").trim().toLowerCase();

export const findStaticScheme = (schemeType) =>
  STATIC_SCHEMES.find((s) => normalize(s.schemeType) === normalize(schemeType));

export const mergeSchemes = (dbSchemes = []) => {
  const staticKeys = STATIC_SCHEMES.map((s) => normalize(s.schemeType));

  const staticSlots = STATIC_SCHEMES.map((staticItem) => {
    const dbMatch = dbSchemes.find(
      (d) => normalize(d.schemeType) === normalize(staticItem.schemeType),
    );
    return dbMatch
      ? { ...dbMatch, isStatic: true }
      : { ...staticItem, schemeId: null, isStatic: true };
  });

  const others = dbSchemes.filter(
    (d) => !staticKeys.includes(normalize(d.schemeType)),
  );

  return [...staticSlots, ...others];
};
